import React, { useRef, useState } from "react";
import "./Verification.css";
import vendorimg from "../../../assets/Component 24.png";
import finkraft from "../../../assets/finkraft.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { auth } from '../../../firebase'; // your firebase config
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify"; // Make sure this is imported

const VerificationPage = () => {
    const inputRefs = useRef([]);
    const { state } = useLocation();
  const { email, password } = state || {};
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const navigate = useNavigate();
  const [otpError, setOtpError] = useState("");
  const [showResendModal, setShowResendModal] = useState(false);




  const handleInputChange = (e, index) => {
    const val = e.target.value;
    const newOtp = [...otp];
  
    // If user pastes the OTP directly in the field
    if (val.length > 1) {
      const valArr = val.slice(0, 6).split('');
      for (let i = 0; i < 6; i++) {
        newOtp[i] = valArr[i] || '';
        if (inputRefs.current[i]) {
          inputRefs.current[i].value = valArr[i] || '';
        }
      }
      setOtp(newOtp);
      return;
    }
  
    newOtp[index] = val;
    setOtp(newOtp);
  
    if (val.length === 1 && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData('text').trim().slice(0, 6);
    const newOtp = [...otp];
    for (let i = 0; i < 6; i++) {
      newOtp[i] = pasteData[i] || '';
      if (inputRefs.current[i]) {
        inputRefs.current[i].value = pasteData[i] || '';
      }
    }
    setOtp(newOtp);
  };

  const [resendCooldown, setResendCooldown] = useState(false);

const handleResend = async () => {
  if (resendCooldown) return;

  setResendCooldown(true);
  setTimeout(() => setResendCooldown(false), 30000); // 30 seconds cooldown

  try {
    const res = await fetch("https://vendor-score.finkraftai.com/send-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (data.success) {
      setShowResendModal(true);
    } else {
      toast.error(data.error || "Failed to resend OTP");
    }
  } catch (err) {
    console.error("Resend OTP failed", err);
    toast.error("Something went wrong while resending OTP");
  }
};

  
  
  



const handleVerify = async () => {
  const otpCode = otp.join('');

  if (otpCode.length !== 6) {
    toast.error("Enter full 6-digit OTP");
    return;
  }

  try {
    // Verify OTP with backend
    const res = await fetch("https://vendor-score.finkraftai.com/verify-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp: otpCode }),
    });

    const data = await res.json();

    if (data.success) {
      try {
        // Register with Firebase
        await createUserWithEmailAndPassword(auth, email, password);
        
        // Get JWT token
        const tokenRes = await fetch("https://vendor-score.finkraftai.com/create-token", {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: 'include',
          body: JSON.stringify({ email }),
        });

        const tokenData = await tokenRes.json();
        
        if (tokenData.access_token) {
          localStorage.setItem("token", tokenData.access_token);
          localStorage.setItem("email", email);
          toast.success("Registration complete!");
          navigate("/pd", { state: { email } });
        } else {
          toast.error('Failed to get authentication token');
        }
      } catch (firebaseErr) {
        if (firebaseErr?.code === "auth/email-already-in-use") {
          toast.info("Email already registered. Proceeding to next step.");
        } else {
          console.error("Firebase error:", firebaseErr);
          toast.error("Error creating user in Firebase");
          return;
        }
      }
    } else {
      setOtpError("Invalid OTP");
    }
  } catch (err) {
    console.error("Verification failed", err);
    toast.error("Something went wrong during verification");
  }
};



  return (
  <div className="login-page-main">
      {showResendModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <h3>OTP Resent!</h3>
      <p>Please check your email for the new OTP.</p>
      <button className="close-btn" onClick={() => setShowResendModal(false)}>
        OK
      </button>
    </div>
  </div>
)}

    <ToastContainer position="top-center" autoClose={3000} />
    <div className="login-container">
      <div className="logo">
        <img src={finkraft} alt="Logo" className="logo-img" />
      </div>

      <div className="login-box">
        <h1 className="welcome-text">Verification code</h1>
        <p className="subtext">Kindly enter the code below sent to {email}</p>
        

        <div className="otp-container">
            {Array.from({ length: 6 }).map((_, index) => (
              <input
              key={index}
              type="text"
              maxLength="1"
              className="otp-input"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d?$/.test(value)) {
                  handleInputChange(e, index);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Backspace' && !e.target.value && index > 0) {
                  inputRefs.current[index - 1].focus();
                }
              }}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              onPaste={handlePaste}
              ref={(el) => (inputRefs.current[index] = el)}
            />
            
            
            ))}

          </div>
          {otpError && (
  <p className="error-message">{otpError}</p>
)}

        <button className="continue-button" style={{marginTop:'10px'}} onClick={handleVerify}>Continue</button>

        <p className="signup-text">
        Didn't get it?<a onClick={handleResend}
  style={{
    color: resendCooldown ? 'gray' : '#007b8f',
    cursor: resendCooldown ? 'not-allowed' : 'pointer'
  }}> Resend Code</a> or<Link to='/welcome'> Change Email Address.</Link>
        </p>
      </div>
    </div>
    <div className="vendor-image-container">
        <img src={vendorimg}  className="vendor-image"/>
    </div>
    </div>
    
  );
};

export default VerificationPage;
